<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.treatments', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">

                <template v-if="rows">

                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mTreatments"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="treatments-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mTreatments"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-treatment', params: { treatment: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.treatments', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.title }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteTreatment(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="treatments-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Treatments",

        computed: {
            ...mapGetters(["treatments"]),

            mTreatments: function() {
                let tArray = [];

                _.forEach(this.treatments, function(treatment) {
                    let t = {};

                    t.title = treatment.intitule;
                    t.description = treatment.description.length > 20 ? treatment.description.substr(0, 20) + '...' : treatment.description;
                    t.date = moment(treatment.created_at).format('DD-MM-YYYY HH:mm');
                    t.id = treatment.id;
                    t.slug = treatment.slug;

                    tArray.push(t);
                });

                return tArray;
            },

            rows: function() {
                return this.mTreatments.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'title',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description'),
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getTreatments() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getTreatments', { args : args });
            },

            formattedDisplay (result) {
                return result.title;
            },

            itemSelected(item) {
                this.$router.push({ name: 'treatment', params: { treatment: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'treatment', params: { treatment: items[0].slug } });
            },

            deleteTreatment(treatment) {
                let self = this;

                let args = {
                    treatment: treatment
                };

                let successMessage = this.$i18n.t('message.treatmentDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteTreatment', { args, index: treatment, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + treatment);
                    });
            }
        },

        mounted() {
            // Fetch treatment list
            this.getTreatments();
        }
    }
</script>

<style scoped>

</style>